import { render } from "./email-settings-modal.vue?vue&type=template&id=46e42a74"
import script from "./email-settings-modal.vue?vue&type=script&lang=js"
export * from "./email-settings-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__